import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CalendarItem from "../CalendarItem";
import PaginationControls from "shared/PaginationControls";
import SearchBar from "shared/SearchBar";
import styles from "./CalendarEventsList.module.css";
import Card from "shared/Card";

/** Displays a list of calendar events with pagination and a search bar.*/
export function CalendarEventsList({ calendarEvents }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [filteredEvents, setFilteredEvents] = useState(calendarEvents);
  const [pagedEventsList, setPagedEventsList] = useState([]);

  //Filters events based on search bar changing
  useEffect(() => {
    let newFilteredEvents = [...calendarEvents];
    if (searchValue !== "") {
      newFilteredEvents = newFilteredEvents.filter((event) => {
        const eventDate = new Date(event.date);
        const formattedDate1 = eventDate.toLocaleString("en-US", {
          month: "long",
          day: "numeric",
        }); // December 30
        const formattedDate2 = `${eventDate.getDate()} ${eventDate.toLocaleString(
          "en-US",
          { month: "long" }
        )}`; // 30 December

        return (
          event.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          event.location.toLowerCase().includes(searchValue.toLowerCase()) ||
          formattedDate1.includes(searchValue) ||
          formattedDate2.includes(searchValue)
        );
      });
    }
    setFilteredEvents(newFilteredEvents);
  }, [searchValue, calendarEvents]);

  //   Pagination
  let resultsPerPage = 16;
  const lastUpcomingEventsPage = Math.ceil(
    filteredEvents.length / resultsPerPage
  );

  useEffect(() => {
    const firstUpcomingEventsPage = (currentPage - 1) * resultsPerPage;
    const lastUpcomingEventsPage = firstUpcomingEventsPage + resultsPerPage;

    setPagedEventsList(
      filteredEvents.slice(firstUpcomingEventsPage, lastUpcomingEventsPage)
    );
  }, [currentPage, filteredEvents]);

  const onPagedEventsChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleViewing = (event) => {
    //This will need to lead to the details page of the selected event
    alert(`Linking to details page of: ${event.name}`);
  };

  return (
    <Card className={styles.container}>
      <div className={styles.header}>
        <p className={styles.bold}>Upcoming</p>
        <div className={styles.search}>
          <p className={styles.bold}>Search</p>
          <SearchBar
            placeholderText="(Search by...)"
            onInput={(e) => setSearchValue(e)}
            searchDelay={250}
          />
        </div>
      </div>
      <span className={styles.line} />

      <div className={styles.list}>
        {pagedEventsList.map((event, index) => (
          <div key={index}>
            <CalendarItem
              eventDetails={event}
              index={index}
              onClick={handleViewing}
            />
          </div>
        ))}
      </div>

      {filteredEvents.length <= resultsPerPage ? null : (
        <div className={styles.paging}>
          <PaginationControls
            page={currentPage}
            lastPage={lastUpcomingEventsPage}
            onPageChange={onPagedEventsChange}
            disableNext={currentPage === lastUpcomingEventsPage}
            color="#1F3BD8"
          />
        </div>
      )}
    </Card>
  );
}

CalendarEventsList.propTypes = {
  /**Array of upcoming Calendar Events */
  calendarEvents: PropTypes.array,
};
